import { FC, useState } from 'react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip.tsx'
import { Info as InfoIcon } from 'lucide-react'

type InfoProps = {
    description: string
}

export const Info: FC<InfoProps> = ({ description }) => {
    const [color, setColor] = useState('var(--color-mm-gray)')

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <InfoIcon
                    color={color}
                    size={12}
                    className={'transition-color'}
                    onMouseEnter={() => setColor('var(--color-mm-gray2)')}
                    onMouseLeave={() => setColor('var(--color-mm-gray)')}
                />
            </TooltipTrigger>
            <TooltipContent>
                <p>{description}</p>
            </TooltipContent>
        </Tooltip>
    )
}
